import { oktaAuthConfigMg, oktaAuthConfigMrv, oktaAuthConfigPrv } from "../config";
import { PageSize, ScreenNames } from "./Constants";
import moment from "moment";
import { isInternaluser } from "../api/auth/okta";
export var eApplicationName;
(function (eApplicationName) {
    eApplicationName["marketReview"] = "MarketReView";
    eApplicationName["marketPreview"] = "MarketPreView";
    eApplicationName["marketGuide"] = "Market Guide";
})(eApplicationName || (eApplicationName = {}));
export var getApplicationConfig = function () {
    var location = window.location.hostname;
    //const location = "https://qamarketpreview.abconnect.com/";
    //const location="https://qamarketreview.abconnect.com/";
    //const location="https://qamarketguide.abconnect.com/";
    if (location.includes("preview")) {
        return ({
            oktaConfig: oktaAuthConfigPrv,
            applicationName: eApplicationName.marketPreview,
            vitePublicUrl: import.meta.env.VITE_PUBLIC_URL_Prv,
            callbackUrl: ScreenNames.callbackprv,
            applicationId: 1,
        });
    }
    else if (location.includes("review")) {
        return ({
            oktaConfig: oktaAuthConfigMrv,
            applicationName: eApplicationName.marketReview,
            vitePublicUrl: import.meta.env.VITE_PUBLIC_URL_Mrv,
            callbackUrl: ScreenNames.callbackmrv,
            applicationId: 2
        });
    }
    else if (location.includes("guide")) {
        return ({
            oktaConfig: oktaAuthConfigMg,
            applicationName: eApplicationName.marketGuide,
            vitePublicUrl: import.meta.env.VITE_PUBLIC_URL_MG,
            callbackUrl: ScreenNames.callbackmg,
            applicationId: 3
        });
    }
    else {
        return ({
            oktaConfig: oktaAuthConfigMrv,
            applicationName: eApplicationName.marketReview,
            vitePublicUrl: import.meta.env.VITE_PUBLIC_URL_Mrv,
            callbackUrl: ScreenNames.callbackmrv,
            applicationId: 2
        });
    }
};
export var getDDMMYYYY = function (date) {
    if (!date) {
        return '';
    }
    ;
    // const newDate = new Date(date);
    // return moment(newDate).format("MM/DD/YYYY")
    var jsDate = moment(date).toDate();
    var formattedDate = jsDate.toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "2-digit" });
    return formattedDate;
};
export var getmarketNamefromType = function (id) {
    switch (id) {
        case 1:
            return "P&c";
        case 2:
            return "Life";
        case 3:
            return "Health";
        case 4:
            return "Lloyd's Syndicate";
        case 5:
            return "Lloyd's Consortium";
        case 6:
            return "Intermediary";
        case 7:
            return "Branch";
        case 8:
            return "Captive";
        case 9:
            return "Alternative ";
        case 10:
            return " Processing Only";
        case 99:
            return "Unassigned";
        default:
            return "";
    }
};
export var formatDate = function (date) {
    if (!date) {
        return '';
    }
    ;
    // date = new Date(date);
    // return moment(date).format("MM/DD/YYYY")
    var jsDate = moment(date).toDate();
    var formattedDate = jsDate.toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "2-digit" });
    return formattedDate;
};
export var isExternalReviewOrPreviewUser = function () {
    var application = getApplicationConfig();
    var isMarketReviewOrPreview = application.applicationId === 1 || application.applicationId === 2;
    return !isInternaluser() && isMarketReviewOrPreview;
};
export var getDefaultHomeGridPageSize = function () {
    return isExternalReviewOrPreviewUser() ? PageSize.EXTERNAL_DEFAULT : PageSize.INTERNAL_DEFAULT;
};
export var ColumnView;
(function (ColumnView) {
    ColumnView["marketStatus"] = "MARKET_STATUS";
    ColumnView["Rating_Profile_financial"] = "RATING_PROFILE_FINANCIAL";
})(ColumnView || (ColumnView = {}));
export var showMarket;
(function (showMarket) {
    showMarket["Favorite"] = "Favorites";
    showMarket["new_subscribe"] = "new_subscribe";
    showMarket["all"] = "All";
})(showMarket || (showMarket = {}));
